import {
  AuthType,
  GetGraphUserInfo,
  GetUserInfoFromO365JwtToken,
  GetUserInfoWithCache,
  IAuthenticatedUserInfo,
  IGetUserInfo,
  isMsa,
  LocalStorageCacheWithExpiry
} from '@notes/webintegrations-common'
import { getAuthTypeWithExtension } from '../../agave/auth/getAuthTypeWithExtension'

export class GetUserInfoFactory {
  static create(authType: AuthType, cache: LocalStorageCacheWithExpiry<IAuthenticatedUserInfo>): IGetUserInfo {
    if (isMsa(authType)) {
      return new GetUserInfoWithCache(new GetGraphUserInfo(), cache)
    }
    return new GetUserInfoWithCache(new GetUserInfoFromO365JwtToken(), cache)
  }

  static createIfAuthenticated(cache: LocalStorageCacheWithExpiry<IAuthenticatedUserInfo>): IGetUserInfo | undefined {
    const authType = getAuthTypeWithExtension()
    return authType && GetUserInfoFactory.create(authType, cache)
  }
}
